export default {
  lstTab: {
    overview: 'Overview',
    orderStatistic: 'Order Statistic',
    foreign: 'Foreign',
    proprietary: 'Proprietary',
  },

  rateList: {
    FromDate: '01/01/2019',
    ToDate: '01/03/2019',
  },

  lstTitleDate: {
    from: 'From',
    to: 'To',
  },

  defaultRateFrom: 'FromDate',
  defaultRateTo: 'ToDate',

  priceDataTableOverview: {
    DATE: 'DATE',
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    OPEN: 'OPEN',
    HIGH: 'HIGH',
    LOW: 'LOW',
    OPEN_INDEX: 'OPEN',
    HIGH_INDEX: 'HIGH',
    LOW_INDEX: 'LOW',
    AVERAGE_PRICE: 'AVG. PRICE',
    MATCHED_VOLUME: 'MATCHED<br> VOLUME', // have space after <br>
    MATCHED_VALUE: 'MATCHED<br> VALUE', // have space after <br>
    PUT_THROUGH_VOL: 'PUT THROUGH<br> VOL.', // have space after <br>
    PUT_THROUGH_VALUE: 'PUT THROUGH<br> VALUE', // have space after <br>
    TOTAL_VOL: 'TOTAL VOL.',
    TOTAL_VALUE: 'TOTAL VALUE',
  },

  priceDataTableOrderStatistic: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    NR_OF_BUY_ORDER: 'NR.OF<br> BUY ORDER', // have space after <br>
    BUY_VOL: 'BUY VOL',
    VOLUMN_BUY_ORDER: 'VOLUME/<br>BUY ORDER',
    NR_OF_SELL_ORDER: 'NR.OF<br> SELL ORDER', // have space after <br>
    SELL_VOL: 'SELL VOL',
    VOLUMN_SELL_ORDER: 'VOLUME/<br>SELL ORDER',
    NET_VOL: 'NET VOL.',
  },

  priceDataTableForeign: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    BUY_ORDER_VOL: 'BUY ORDER<br> VOL.', // have space after <br>
    BUY_ORDER_VALUE: 'BUY ORDER<br> VALUE', // have space after <br>
    SELL_ORDER_VOL: 'SELL ORDER<br> VOL.', // have space after <br>
    SELL_ORDER_VALUE: 'SELL ORDER<br> VALUE', // have space after <br>
    NET_VOLUME: 'NET VOLUME',
    NET_VALUE: 'NET VALUE',
    OWNED_RATIO: 'OWNED RATIO',
    FOREIGN_ROOM: 'FOREIGN ROOM',
  },

  priceDataTableProprietary: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    BUY_VOL: 'BUY VOL.',
    BUY_VALUE: 'BUY VALUE',
    SELL_VOL: 'SELL VOL.',
    SELL_VALUE: 'SELL VALUE',
    NET_VOL: 'NET VOL.',
    NET_VALUE: 'NET VALUE',
  },

  listTimeRangeByKey: {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
  },

  indexInfo: {
    Open: 'O',
    Hight: 'H',
    Low: 'L',
    Bid: 'BID',
    Ask: 'ASK',
  },

  footerText1:
    'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000. Exercise Date is marked with the arterisk.',
  footerText2: 'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000',
};
